import { render, staticRenderFns } from "./ShippingAddress.vue?vue&type=template&id=5058a28c"
import script from "./ShippingAddress.vue?vue&type=script&lang=ts"
export * from "./ShippingAddress.vue?vue&type=script&lang=ts"
import style0 from "./ShippingAddress.vue?vue&type=style&index=0&id=5058a28c&prod&slot-scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports